module.exports = __webpack_public_path__ + "img/footer-line.944d48a9.svg";